export default {
    apparent_1: 'Apparent',
    apparent_2: 'Inapparent',
    apparent_3: 'Any',
};
